// extracted by mini-css-extract-plugin
module.exports = {"root":"Breadcrumbs_root__31W8J","breadcrumb":"Breadcrumbs_breadcrumb__Movpj","active":"Breadcrumbs_active__2UDY7","arrow":"Breadcrumbs_arrow__3dpa3"};